import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface PatientDentalProcedureParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientDentalProcedure {

    id?: number;
    procedureNotes: string;   
    procedureId: any;
    price:any;


    visitId:any;
    regId: string;     
    tenantId: any;
    branchId: any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientDentalProcedureParameter[];
    links?: any;

}

export abstract class PatientDentalProcedureData { 

    abstract list(url: string): Observable<PatientDentalProcedure[]>;
    abstract create(url: string, data: PatientDentalProcedure): Observable<any>;
    abstract update(url: string, data: PatientDentalProcedure): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}
